<template>
    <div>
        <div v-if="displayModalJackpot">
            <modal-jackpot @openclosedmodal="openjackpot" v-bind:skin="skin" />
        </div>
        <!-- Button trigger modal -->
        <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
            style="display:none;"></button>
        <button id="payment_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#payment"
            style="display:none;"></button>
        <button id="withdraw_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#withdraw"
            style="display:none;"></button>
        <nav v-if="user.token !== ''" class="navbarCustom navbar-dark py-0" id="mainHeader">
            <div class="d-flex align-items-center justify-content-between p-2 py-2 flex-wrap"
                :style="skin.header_mobil.nav_bar" style="width: 100%; max-height: 50px;">

                <!-- Botón de Depósito -->
                <div v-if="user.token != '' && skin.auto_payment?.enabled" @click="payment"
                    :style="skin.header_desktop.login_btn" class="btn btn-sm text-end d-flex align-items-center mx-1"
                    style="font-size: 5px;">
                    <!-- <i class="fas fa-plus fa-fw me-1" style="font-size: 10px;"></i> -->
                    <span style="font-size: 10px;">DEPOSIT</span>
                </div>

                <!-- Botón de Retiro -->
                <div v-if="user.token != '' && skin.auto_payment?.enabled" @click="withdraw"
                    :style="skin.header_desktop.login_btn" class="btn btn-sm text-end d-flex align-items-center mx-1"
                    style="font-size: 5px;">
                    <!-- <i class="fas fa-minus fa-fw me-1" style="font-size: 10px;"></i> -->
                    <span style="font-size: 10px;">WITHDRAW</span>
                </div>


                <!-- Logo -->
                <div style="flex: 1; text-align: center;" @click="change_view('lobby')">
                    <img :src="skin.header_mobil.logo" :width="skin.header_mobil.logo_width" alt="">
                </div>

                <!-- Botón de Acción Personalizado -->
                <div class="mx-1">
                    <div v-if="skin.customActionButton?.enable" @click="user.token != '' ? action() : login()"
                        class="btn-support" style="font-size: 16px; color: black;"
                        :style="skin.header_desktop.support_btn">
                        <i class="fa fa-external-link fa-fw"></i>
                    </div>
                </div>

                <!-- Soporte Jivo -->
                <div v-if="user.token != '' && skin.jackpot" @click="openjackpot">
                    <button class="jackpot-btn gold-glow" :style="{'--color': skin.header_desktop.jackpot[0],'--color1': skin.header_desktop.jackpot[1],'--colorletter': skin.header_desktop.jackpot[2]}"><svg fill="#000000" width="34px" height="34px"
                            viewBox="0 0 14 14" role="img" focusable="false" aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path
                                    d="m 12.324082,8.1685 -0.05633,0.1972 -0.211224,0.063 -0.213551,0.066 0.211224,0.061 0.211225,0.063 0.06098,0.2113 0.06098,0.2088 0.06575,-0.2112 0.06343,-0.2135 0.19947,-0.054 c 0.108,-0.03 0.190163,-0.063 0.178408,-0.073 -0.0094,-0.01 -0.08914,-0.035 -0.173633,-0.059 -0.08682,-0.021 -0.168979,-0.047 -0.183061,-0.056 -0.01408,-0.01 -0.04922,-0.096 -0.07739,-0.1925 -0.02816,-0.094 -0.05633,-0.1831 -0.06576,-0.1925 -0.0095,-0.01 -0.04004,0.07 -0.07053,0.1808 z M 1.483429,7.2203 C 1.413019,7.462 1.415349,7.455 1.382531,7.4668 c -0.01641,0 -0.110327,0.033 -0.206572,0.061 L 1,7.5818 1.197143,7.6428 c 0.110326,0.035 0.206571,0.078 0.218326,0.096 0.0094,0.019 0.04224,0.1126 0.07041,0.2089 l 0.05167,0.1761 0.05865,-0.1925 c 0.03282,-0.1057 0.07041,-0.2018 0.07984,-0.2112 0.01176,-0.01 0.105673,-0.045 0.211224,-0.078 L 2.079753,7.5811 1.892039,7.5271 C 1.788814,7.4961 1.694896,7.4641 1.680814,7.4521 1.669054,7.4401 1.629144,7.3418 1.596324,7.2362 L 1.535094,7.0437 1.483424,7.2197 Z M 5.623551,5.9365 C 5.316082,6.0398 4.952286,6.3379 4.839633,6.582 l -0.05633,0.122 -0.335633,0 -0.335632,0 L 3.75767,6.9834 C 2.929181,7.6359 2.497303,8.0935 2.236854,8.6004 2.023303,9.0182 1.955221,9.4241 2.030283,9.849 l 0.02584,0.1526 1.037388,0.01 1.037388,0 0.02584,-0.1338 C 4.245879,9.4248 4.457106,8.9484 4.757596,8.5188 4.921922,8.2841 4.940657,8.2466 4.978249,8.0636 5.104984,7.4557 5.464126,6.7586 5.949882,6.1743 6.083718,6.0147 6.118861,5.9607 6.095351,5.9467 6.029591,5.9087 5.7198,5.9047 5.623555,5.9347 Z M 12.432082,4.918 c -0.06808,0.075 -0.347388,0.2089 -0.521021,0.2511 -0.201796,0.049 -0.699428,0.052 -0.941143,0 L 10.798612,5.1361 10.582735,5.3614 C 10.324612,5.629 10.148531,5.8285 9.967796,6.0655 l -0.133714,0.1737 0.206571,0.066 c 0.227633,0.075 0.504612,0.1337 0.661837,0.1431 l 0.103224,0.01 L 10.432612,6.74 C 9.730857,7.2681 9.12302,7.8148 8.939959,8.0801 c -0.08216,0.1197 -0.180735,0.596 -0.201796,0.988 -0.01641,0.2722 0.0023,0.8449 0.02816,0.9153 0.0094,0.026 0.255795,0.03 1.377673,0.03 1.288531,0 1.363592,0 1.347184,-0.042 C 11.41612,9.7812 11.333955,9.4926 11.301016,9.3095 11.249346,9.0044 11.265746,8.3543 11.336286,8.0586 11.531102,7.2207 11.993469,6.4509 12.753878,5.6975 L 13,5.4536 12.739429,5.1625 C 12.596286,5.0053 12.478857,4.8739 12.476531,4.8739 c -0.0023,0 -0.02339,0.021 -0.04445,0.045 z m -11.162204,0.8355 0,0.9739 0.455265,0 c 0.431877,0 0.457714,0 0.471796,-0.044 0.02351,-0.075 0.345061,-0.3615 0.485877,-0.4319 0.07273,-0.038 0.187715,-0.073 0.262898,-0.08 l 0.131388,-0.014 0,-0.6806 0,-0.6806 -0.194816,0.012 c -0.131388,0.01 -0.241715,0.033 -0.347388,0.075 -0.08449,0.033 -0.176082,0.061 -0.204122,0.061 -0.06098,0 -0.122082,-0.059 -0.122082,-0.1197 0,-0.042 -0.02106,-0.045 -0.469347,-0.045 l -0.469469,0 0,0.9741 z m 2.065346,-0.6806 0,1.3729 0.640776,0 0.638327,0 0.0469,-0.082 C 4.719877,6.2535 5.015595,5.9742 5.194003,5.8592 5.597717,5.5965 5.900411,5.5893 6.635105,5.8242 7.095146,5.9697 7.346289,6.026 7.616166,6.0448 l 0.229959,0.014 -0.396734,0.2981 c -0.852,0.6336 -1.488,1.1687 -1.891592,1.5889 -0.849551,0.8848 -1.227429,1.7062 -1.182857,2.5699 0.0094,0.1572 0.03049,0.3474 0.0469,0.4248 l 0.03049,0.1408 2.189755,0.01 c 1.750898,0 2.187306,0 2.178,-0.023 C 8.587801,10.5378 8.477474,9.9887 8.475148,9.3667 8.472848,7.8506 9.174576,6.3932 10.566332,5.0155 L 10.934781,4.6517 10.573311,4.248 C 10.373842,4.025 10.204862,3.8443 10.19776,3.8443 c -0.0071,0 -0.05865,0.038 -0.110326,0.084 C 9.95127,4.0456 9.653229,4.1841 9.402087,4.2475 9.219025,4.2945 9.132209,4.3015 8.744903,4.2995 8.155801,4.2995 7.975066,4.2645 6.949434,3.9662 5.989556,3.6845 5.569434,3.6634 5.060168,3.8653 4.961598,3.9053 4.855923,3.9383 4.82776,3.9383 4.75735,3.9383 4.672862,3.8443 4.672862,3.767 l 0,-0.063 -0.668939,0 -0.668938,0 0,1.3731 z M 5.801837,4.1834 c 0.05633,0.068 -0.0047,0.1127 -0.183061,0.1409 -0.08914,0.012 -0.227633,0.049 -0.30747,0.077 -0.154898,0.059 -0.215877,0.045 -0.215877,-0.044 0,-0.061 0.04922,-0.092 0.239387,-0.1549 0.204245,-0.066 0.420123,-0.075 0.467021,-0.019 z m 0.267551,6.4049 0,0.07 -0.612612,0.01 c -0.657184,0.01 -0.69,0 -0.654858,-0.1127 0.01408,-0.047 0.02584,-0.047 0.640653,-0.042 l 0.626694,0.01 0,0.07 z M 8.827061,3.0826 c -0.02816,0.1009 -0.06331,0.1948 -0.07984,0.2089 -0.01408,0.014 -0.09392,0.045 -0.178408,0.068 -0.234734,0.063 -0.237061,0.07 -0.01408,0.1314 l 0.204122,0.056 0.06343,0.2112 0.06588,0.2089 0.054,-0.1854 c 0.03049,-0.1032 0.06331,-0.1994 0.07506,-0.2112 0.01176,-0.014 0.110327,-0.052 0.215878,-0.084 L 9.425593,3.4254 9.249511,3.3734 C 9.153271,3.3454 9.059348,3.3144 9.040613,3.3054 9.021883,3.2954 8.981963,3.2045 8.953793,3.1012 8.923303,3.0003 8.895143,2.9134 8.890363,2.9087 c -0.0045,0 -0.03269,0.075 -0.06331,0.1737 z">
                                </path>
                            </g>
                        </svg></button>
                </div>
                <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_mobil.support && user.token != ''"
                    class="text-end" style="cursor:pointer;">
                    <div class="btn-support" @click="openSupportModalJivo()" style="font-size: 16px; color: black;"
                        :style="skin.header_desktop.support_btn + (this.message_recived ? 'color:white;' : '')">
                        <i class="fas fa-comment fa-fw"></i>
                    </div>
                </div>

                <!-- Información de Usuario -->
                <div class="user-info mx-1">
                    <div class="avatar px-2 py-1 pb-0">
                        <i class="fa fa-user"></i>
                    </div>
                </div>

                <!-- Saldo del Usuario -->
                <div v-if="user.token != '' && skin.header_mobil.balance" class="text-start" style="font-size: small;">
                    <span style="color:white;">{{ user.user_data.data ? user.user_data.data.user_name : '' }}</span>
                    <br>
                    <span @click="showBalanceAction" style="color:white;">
                        {{ user.user_data.data ? new Intl.NumberFormat("de-DE", {
                            minimumFractionDigits: skin.qBet_config.decimalsQty,
                            maximumFractionDigits: skin.qBet_config.decimalsQty
                        }).format(balance.saldo) : 0 }}
                    </span>
                </div>

                <!-- Selector de Idioma -->
                <div>
                    <languageSelector :skin="skin" :language="language">
                    </languageSelector>
                </div>

                <!-- Botón Menú -->
                <div>
                    <span class="position-relative me-1 my-1" data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasExample2" aria-controls="offcanvasExample2" style="width: 10%;">
                        <span :style="{ 'color': skin.main_modal_background }" style="font-size: large;">
                            <i class="fas fa-bars"></i>
                        </span>
                    </span>
                </div>
            </div>
        </nav>

        <nav v-if="user.token == ''" class="navbarCustom navbar-dark py-0" id="mainHeader">
            <div class="d-flex align-items-center justify-content-between p-1 py-1" :style="skin.header_mobil.nav_bar"
                style="width: 100%; min-height: 50px;">
                <div style="width: 60%;">
                    <img class="mx-2" :src="skin.header_mobil.logo" :width="skin.header_mobil.logo_width" alt="">
                </div>
                <div>
                    <languageSelector :skin="skin" :language="language">
                    </languageSelector>
                </div>
                <div style="cursor:pointer;font-size: 11px;font-weight: bold;" class="btn mx-2 py-1 px-1 btn-outline"
                    :style="skin.header_mobil.login_btn" v-if="user.token == ''" @click="login">
                    <span>{{ translate("log_in") }}</span>
                </div>
                <div>
                    <button v-if="user.token == '' && skin.register" style="font-size: small;"
                        class="p-1 px-2 pe-2 me-1 text-center btn" @click="register"
                        :style="skin.header_mobil.register_btn">{{ translate("sign_in") }}</button>
                </div>
                <div>
                    <span class="position-relative me-1" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample2"
                        aria-controls="offcanvasExample2">
                        <span :style="{ 'color': skin.main_modal_background }" style="font-size: larger;"><i
                                class="fas fa-bars"></i></span>
                    </span>
                </div>
            </div>
        </nav>
        <div>
            <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
                style="display:none;"></button>
            <myAccountZeus v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <payment v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <withdraw v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <login2 v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <register v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        </div>
    </div>
</template>

<script>
import ModalJackpot from "../../globaljackpot/ModalJackpot.vue";
import myAccountZeus from "./my_account.vue";
import login2 from "./login.vue";
import register from './register.vue';
import languageSelector from './language.vue';
import changePassword from "./changePassword.vue";

import withdraw from "../../payments/withdraw.vue";
import payment from "../../payments/payment.vue";
export default {
    name: "header_mobil2",
    props: ["skin", "translation", "language"],
    components: {
        myAccountZeus,
        login2,
        payment,
        withdraw,
        register,
        languageSelector,
        changePassword,
        ModalJackpot
    },
    data() {
        return {
            displayModalJackpot: false,
            userDataLoaded: false,
            showBalance: false,
            supportTickets: [],
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            }
        }
    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
    },
    methods: {
        openjackpot() {
            this.displayModalJackpot = !this.displayModalJackpot;
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        },
        payment() {
            document.getElementById('payment_btn').click();
            this.$store.dispatch('setPayment')
        },
        withdraw() {
            document.getElementById('withdraw_btn').click();
            this.$store.dispatch('setPayment2')
            this.$store.dispatch('setWithdraw')
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        show_user_recharge() {
            this.$root.$emit("show_user_recharge");
        },
        openSupportModalJivo() {
            const jivoMobileElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'none'; // Ocultar el elemento móvil
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'block'; // Mostrar el elemento móvil
                    jivo_api.open()
                }
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);
            }
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        login() {
            document.getElementById('login_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        register() {
            document.getElementById('register_btn').click();
        },
        change_view(view) {
            this.$store.dispatch('setView', view);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        }
    },
    watch: {
        'user.token'(newVal) {
            if (newVal !== '' && this.skin.jackpot) {
                this.openjackpot();
            }
        },
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
        window.addEventListener('resize', () => { this.setMenuCenter(); });
        this.$root.$on('openLogin', () => {
            this.login();
        });
    },
    created() {
        const self = this;
        let balanceRequestTime = 8000;
        var saldo_request = setInterval(function () {
            try {
                if (self.user.user_data.data) {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId: self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                }
            } catch (error) {
                this.$store.dispatch('logOut');
                clearInterval(saldo_request);
            }
        }, balanceRequestTime);
    },
    beforeDestroy() {
        this.$root.$off('openLogin');
    }
}
</script>

<style scoped>
@keyframes blink {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.05);
        opacity: 0.7;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.jackpot-btn {
    margin-right: 4px;
    animation: blink 1.5s infinite ease-in-out;
    transition: all 0.3s ease-in-out;
    font-size: 20px;
    font-weight: bold;
    width: 34px;
    /* Igual ancho y alto para círculo */
    height: 34px;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    /* Círculo */
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.jackpot-btn:hover {
    animation: none;
}

.gold-glow {
    background: linear-gradient(45deg, var(--color), var(--color1));
    color: var(--colorletter);
    box-shadow: 0 0 15px var(--color);
}

.gold-glow:hover {
    box-shadow: 0 0 30px var(--color);
}

.btn-support {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    min-width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}

.navbarCustom {
    /* position: fixed; */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.avatar {
    width: 38px;
    height: 38px;
    border-radius: 6px;
    text-align: center;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
    background: #1c1c1c;
    border: 1px solid #fff;
    font-size: 1.6rem !important;
    vertical-align: middle;
    color: #fff;
    padding-top: 5px;
}

.btn-outline {
    background-color: rgba(0, 0, 0, 0);
    border: 2px solid #fff;
    color: #fff !important;
    margin: 0;
}
</style>./changePassword.vue./login.vue./my_account.vue